(function () {
    'use strict';

    var insertedPositions = new Set();

    function getProductList(container) {
        return container ? container.querySelector('.product-list') : null;
    }

    function collectTemplates(container) {
        var blob = container.querySelector('#promo-tiles-data');
        if (!blob) return [];
        return Array.prototype.map
            .call(blob.querySelectorAll('template[data-promo-tile]'), function (tpl) {
                return { position: parseInt(tpl.getAttribute('data-position'), 10), node: tpl };
            })
            .sort(function (a, b) { return a.position - b.position; });
    }

    function currentCardCount(productList) {
        return productList.querySelectorAll(':scope > *:not(.promo-tile)').length;
    }

    function injectDue(container) {
        var productList = getProductList(container);
        if (!productList) return;
        var templates = collectTemplates(container);
        if (!templates.length) return;

        var cardCount = currentCardCount(productList);

        templates.forEach(function (t) {
            if (insertedPositions.has(t.position)) return;
            if (t.position > cardCount) return; // not enough cards loaded yet

            var clone = t.node.content.firstElementChild.cloneNode(true);
            var cards = productList.querySelectorAll(':scope > *:not(.promo-tile)');
            var refNode = cards[t.position] || null; // insert BEFORE the card at this index = AFTER position-th card
            productList.insertBefore(clone, refNode);
            insertedPositions.add(t.position);
        });
    }

    function resetAndInject(container) {
        insertedPositions.clear();
        injectDue(container);
    }

    function allCollectionContainers() {
        return document.querySelectorAll('.filters-adjacent.collection-listing');
    }

    document.addEventListener('DOMContentLoaded', function () {
        allCollectionContainers().forEach(resetAndInject);

        // watch for ajax-filter driven full replacement of this container
        allCollectionContainers().forEach(function (container) {
            new MutationObserver(function () {
                resetAndInject(container);
            }).observe(container, { childList: true });
        });
    });

    // re-run after each Load More append
    document.addEventListener('cc:load-more:appended', function (evt) {
        var listEl = evt.detail && evt.detail.container;
        var container = listEl ? listEl.closest('.filters-adjacent.collection-listing') : null;
        if (container) injectDue(container);
    });
})();